import { ContentState, EditorState, convertFromHTML } from "draft-js";

export const textToEditorState = (text: string): EditorState => {
    const textBlocks = convertFromHTML(text).contentBlocks;
    const contentState = ContentState.createFromBlockArray(textBlocks);
    return EditorState.createWithContent(contentState);
}
